"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
import { Component, Vue } from "vue-property-decorator";
let CountDown = class extends Vue {
  constructor() {
    super(...arguments);
    this.timer = 3600;
  }
  mounted() {
    this.startTimer();
  }
  get minutes() {
    return Math.floor(this.timer / 60);
  }
  get seconds() {
    const sec = this.timer % 60;
    return sec < 10 ? "0" + sec : sec;
  }
  startTimer() {
    this.timerInterval = setInterval(() => {
      this.timer--;
      if (this.timer === 0) {
        clearInterval(this.timerInterval);
        this.$emit("timeout");
      }
    }, 1e3);
  }
};
CountDown = __decorateClass([
  Component({
    components: {}
  })
], CountDown);
export {
  CountDown as default
};
